export default "__VITE_ASSET__BlrsPOuY__"